import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
})
export class AvatarComponent implements OnInit, OnChanges {
  @Input() data: any = '';
  name : string = '';
  initials: string = '';
  avatarColor: string = '';
  fontColor: string = '';

  private static colorMap: { [key: string]: string } = {};
  private static colors: string[] = [
    '#FF5733',
    '#33FF57',
    '#3357FF',
    '#F1C40F',
    '#9B59B6',
    '#E74C3C',
    '#3498DB',
    '#2ECC71',
    '#1ABC9C',
    '#F39C12',
  ];

  ngOnChanges(changes: SimpleChanges): void {
    let tempName = Array.isArray(this.data.metaData?.from_name) ? this.data.metaData.from_name[0] : this.data.metaData.from[0].split('<')[0].trim().replace(/"/g, '');
    if(this.checkValidName(tempName)){
      this.name = tempName;
    }else{
      if(this.checkValidEmail(tempName)){
        this.name = this.getNameFromEmailExcludingNumbers(tempName);
      }else{
        tempName = Array.isArray(this.data.metaData.from) ? this.data.metaData.from[0].split('<')[0].trim().replace(/"/g, '') : this.data.metaData.from;
        this.name = this.getNameFromEmailExcludingNumbers(tempName);
      }
    }
    this.initials = this.name[0].toUpperCase();
    this.avatarColor = this.getColorFromName(this.name);
    this.fontColor = this.getFontColor(this.avatarColor);
  }

  ngOnInit(): void {
  }

  private getColorFromName(name: string): string {
    const normalized = name.toString().toLowerCase();

    if (!AvatarComponent.colorMap[normalized]) {
      const colorIndex = normalized.length % AvatarComponent.colors.length;
      AvatarComponent.colorMap[normalized] = AvatarComponent.colors[colorIndex];
    }

    return AvatarComponent.colorMap[normalized];
  }

  private getFontColor(bgColor: string): string {
    const r = parseInt(bgColor.slice(1, 3), 16);
    const g = parseInt(bgColor.slice(3, 5), 16);
    const b = parseInt(bgColor.slice(5, 7), 16);

    // Calculate luminance
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
    return luminance > 180 ? '#000000' : '#FFFFFF';
  }

  getNameFromEmailExcludingNumbers(email: string): string {
    if (!email || email.indexOf('@') === -1) {
      return email;
    }
    const namePart = email.split('@')[0];
    return namePart.replace(/[0-9]/g, '');
  }

  checkValidName(name: string): boolean {
    if (name.length === 0) {
      return false;
    }
    return /^[a-zA-Z\s]*$/.test(name);
  }

  checkValidEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
}
